import { Box, Flex, Heading, Section, Text } from "@radix-ui/themes";
import styles from "./doctor-intro.module.css";
import { LinkCta } from "~/components/LinkCta";
import {
	useLocalization,
	Locale,
	type LocalizedStrings,
} from "~/components/localization/LocalizationProvider";

type Localization = {
	learnMore: string;
	doctorIntroHeading: string;
	doctorIntroContent: string;
};

const englishLocalization: Localization = {
	doctorIntroHeading: "Meet Dr. Garcia-Paul",
	doctorIntroContent: `As the daughter of a dentist, I learned early-on to appreciate the
details of a beautiful smile, and my focus is to deliver
individualized attention to each of my patients since every smile
is unique. For me, orthodontics is more than just creating
beautiful smiles; it is about forming strong friendships with my
patients and their families. My greatest joy is to see our MOS
family grow and striving to make a lasting difference in my
patients’ lives.`,
	learnMore: "Learn More",
};

const spanishLocalization: Localization = {
	doctorIntroHeading: "Conozca a la Dra. Garcia-Paul",
	doctorIntroContent: `
Como hija de un dentista, aprendí desde muy temprana edad a apreciar los detalles de una sonrisa hermosa, 
y mi objetivo es brindar una atención individualizada a cada uno de mis pacientes, 
ya que cada sonrisa es única. Para mí, la ortodoncia es más que simplemente crear 
sonrisas hermosas; se trata de formar amistades sólidas con mis pacientes y sus familias. 
Mi mayor alegría es ver a nuestra familia MOS crecer y esforzarnos por marcar una diferencia duradera 
en la vida de mis pacientes.`,
	learnMore: "Más información",
};

const localized: LocalizedStrings<Localization> = {
	[Locale.EN]: englishLocalization,
	[Locale.ES]: spanishLocalization,
};

export function DoctorIntro() {
	const getLocalization = useLocalization(localized);
	return (
		<Section pt="0" height="100%" overflow="visible">
			<Flex
				height="100%"
				direction={{ initial: "column", sm: "row" }}
				align="center"
				overflowX="clip"
			>
				<Flex
					className={styles.doctorPortraitContainer}
					flexBasis={{ initial: "100%", sm: "50%" }}
					maxWidth={{ initial: "100%", sm: "50%" }}
					height="100%"
					align="center"
				>
					<img
						className={styles.doctorPortrait}
						src="/intro/Dr-Garcia-Paul.jpg"
						srcSet="/optimized/intro-Dr-Garcia-Paul-352.webp 352w, /optimized/intro-Dr-Garcia-Paul-704.webp 704w"
						sizes="(max-width: 767px) 100vw, 50vw"
						width="704"
						height="704"
						loading="lazy"
						decoding="async"
						alt={getLocalization("doctorIntroHeading")}
					/>
				</Flex>
				<Flex
					flexBasis={{ initial: "100%", sm: "50%" }}
					minHeight="100%"
					height="100%"
					width="100%"
					direction="column"
				>
					<Flex
						maxWidth="690px"
						gapY="5"
						direction="column"
						ml={{ initial: "0", sm: "-100px" }}
						py={{ initial: "7", sm: "120px" }}
						px={{ initial: "4", sm: "60px" }}
						className={styles.doctorIntroContent}
						position="relative"
					>
						<Box
							position="absolute"
							right="-16px"
							bottom="-16px"
							className={styles.introDecoration}
							height="200px"
							width="200px"
						></Box>
						<Heading
							as="h2"
							className={styles.doctorIntroHeading}
							weight="bold"
						>
							{getLocalization("doctorIntroHeading")}
						</Heading>
						<Text size={{ initial: "4", sm: "4" }}>
							{getLocalization("doctorIntroContent")}
						</Text>
						<Box width="fit-content">
							<LinkCta to="/meet-our-doctors/" px="7" py="4">
								{getLocalization("learnMore")}
							</LinkCta>
						</Box>
					</Flex>
				</Flex>
			</Flex>
		</Section>
	);
}
